<template>
  <div class="ledger-content">
    <el-table v-if="logs && logs.length" :data="logs" size="small" border style="width: 100%; margin-top: 8px;">
      <el-table-column prop="create_time" label="操作时间" width="160"></el-table-column>
      <el-table-column prop="scene_text" label="操作类型" width="100"></el-table-column>
      <el-table-column prop="change_value" label="变动金额" width="110">
        <template slot-scope="scope">
          <span :class="{ 'amount-in': isPositive(scope.row.change_value), 'amount-out': !isPositive(scope.row.change_value) }">
            {{ formatChangeValue(scope.row.change_value) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="related_order_no" label="关联订单号" width="160"></el-table-column>
      <el-table-column prop="user.nickName" label="操作用户" width="100">
        <template slot-scope="scope">
          {{ scope.row.user && scope.row.user.nickName ? scope.row.user.nickName : '-' }}
        </template>
      </el-table-column>
    </el-table>
    <div v-else class="empty-logs">暂无流水</div>
  </div>
</template>

<script>
export default {
  name: 'Ledger',
  props: {
    detail: {
      type: Object,
      default: null
    },
    logs: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isPositive(val) {
      if (val === undefined || val === null || val === '') return false;
      return Number(val) > 0;
    },
    formatChangeValue(val) {
      if (val === undefined || val === null || val === '') return '-';
      const num = Number(val);
      const prefix = num >= 0 ? '+' : '';
      return prefix + val;
    }
  }
};
</script>

<style scoped>
.ledger-content .detail-content p {
  margin: 8px 0;
}
.ledger-content .label {
  color: #909399;
  margin-right: 8px;
}
.detail-section {
  margin-top: 16px;
  margin-bottom: 4px;
  font-weight: 500;
  color: #303133;
}
.amount-in {
  color: #67c23a;
}
.amount-out {
  color: #f56c6c;
}
.empty-logs {
  margin-top: 12px;
  color: #909399;
  text-align: center;
  padding: 24px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/gift_card/instance_list/ledger.vue